// ---- auth ----
export const AUTH_LOGIN = "/auth/login";
export const  AUTH_LOGOUT = "/auth/logout";
export const RESET_PASSWORD_REQUEST = "/email/set-password";
export const REFRESH_TOKEN = "/auth/refresh-token";
export const CHANGE_PASSWORD = "/auth/change-password";
export const LOGIN_WITH_GOOGLE = "/auth/login/google";
export const GET_CURRENT_USER_DETAILED_ACCESS = "/user/me";

// ---- organization ----
export const ORG_REGISTER = "/org/add";

// ---- user ----
export const USER_REGISTER = "/user/register";

// ------------- Profile Setting --------------

export const USER_SELF_UPDATE = "/user/self";
export const CONFIRM_PASSWORD = "/auth/confirm-password";
export const SET_PASSWORD = "/user/set-password";
export const VERIFY_PASSWORD_TOKEN = "/user/verify-token";
export const SET_PASSWORD_WITH_TOKEN = "/user/set-password-token";
export const FILE_UPLOAD_URL = "/file/upload-url";
export const FILE_DOWNLOAD_URL = "/file/download-url";
export const FILE_DELETE = "/file/delete";



export const USER_LIST = "/user/all";
export const USER_SEARCH = "/user/search";
export const USER_REGISTER_BY_ADMIN = "/user/registerByAdmin";
export const USER_UPDATE = "/user/"; // append the target user's email
export const USER_DELETE = "/user/delete";
export const USER_UNLOCK = "/user/unlock/"; // append the target user's email
export const USER_RESET_PASSWORD_EMAIL = "/email/set-password";


// ---- supplier ----
export const SUPPLIER_LIST = "/supplier/all";
export const SUPPLIER_SEARCH = "/supplier/search";
export const SUPPLIER_PAGINATED = "/supplier/paginated";
export const SUPPLIER_REGISTER = "/supplier/add";
export const SUPPLIER_UPDATE = "/supplier/"; // append the target supplier's (original) name
export const SUPPLIER_DELETE = "/supplier/delete";
export const SUPPLIER_BY_NAME = "/supplier/byName";



// ---- request ----
export const REQUEST_GROUPED_BY_SUPPLIER = "/request/grouped-by-supplier";
export const REQUEST_FILTER = "/request/filter";
export const REQUEST_ADD = "/request/add";
export const REQUEST_UPDATE = "/request/"; // append the target request's id
export const REQUEST_DELETE = "/request/delete";
export const REQUEST_APPROVE = "/request/approve/"; // append the target request's id
export const REQUEST_STATUS = "/request/status/"; // append the target request's id
export const REQUEST_RECEIVED = "/request/received";
export const REQUEST_PO = "/request/po";
export const REQUEST_APPLY_QUOTATION = "/request/apply-quotation";
export const REQUEST_TYPES = "/request/types";
export const REQUEST_PROJECTS = "/request/projects";
export const REQUEST_MAX_VALUES = "/request/max-values";
 
// ---- request log ----
export const REQUEST_LOG_ADD = "/request-log/add";
export const REQUEST_LOG_BY_REQUEST = "/request-log/by-request";
 
// ---- purchase order ----
export const PO_LAST = "/po/last";
export const PO_ADD = "/po/add";
 
// ---- misc lookups ----
export const USER_NAMES = "/user/names";

// ---- misc ----
export const ORG_GET = "/org";
export const EMAIL_PO = "/email/po";


// --------- inventory -----------

export const INVENTORY_FILE_REMOVE = "/inventory/file-remove";
export const INVENTORY_FILE_UPLOAD = "/inventory/file-upload";
export const INVENTORY_EXPIRE_DUE =  "/inventory/num-due-to-expire";
export const INVENTORY_NUM_EXPIRED = "/inventory/num-expired";
export const INVENTORY_DELETE = "/inventory/delete";
export const INVENTORY_UPDATE = "/inventory";
export const INVENTORY_ADD = "/inventory/add";
export const INVENTORY_GROUPED_BY_NAME = "/inventory/grouped-by-name";
export const INVENTORY_FILTER = "/inventory/filter";

export const INVENTORY_TYPES = "/inventory/types";


// ---- dashboard ----
export const DASHBOARD_SUMMARY = "/dashboard/summary";

// ---- request (add if not already present) ----
export const REQUEST_PENDING_APPROVAL = "/request/pending-approval";
export const REQUEST_DELAYED_ORDERS = "/request/delayed-orders";


// --------------- organization --------------

export const ORG_UPDATE = "/org";
export const ORG_DEACTIVATE = "/org/deactivate";

export const SEARCH_WEB = "/search/web";
export const SEARCH_PREVIEW = "/search/preview";
export const BASE_URL_PREVIEW =
  process.env.REACT_APP_API_SERVER_SSR;